// extracted by mini-css-extract-plugin
module.exports = {"button":"PrimaryInvertedButton_button__11pEB","inverted":"PrimaryInvertedButton_inverted__3lYzg"};